<template>
  <div>
    <PageAllow controller="ShopDailyReports" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("shopDailyReports.orderInfo") }}
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />

          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("shopDailyReports.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ shopDailyReport.order_code }} </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopDailyReports.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ shopDailyReport.created }} </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopDailyReports.Fields.shop_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="shopDailyReport && shopDailyReport.shop">
                    {{ shopDailyReport.shop.shop_name }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopDailyReports.business_date")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ shopDailyReport.business_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("shopDailyReports.operator")
                    }}{{ $t("Global.colon") }}
                  </span>

                  <span v-if="userType == 2">
                    {{(shopDailyReport && shopDailyReport.creater && shopDailyReport.creater.name) ? shopDailyReport.creater.name : "" }}
                  </span>
                  <span v-else>
                    {{(shopDailyReport && shopDailyReport.creater && shopDailyReport.creater.name) ? shopDailyReport.creater.name : accountUser.shop_user_name }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="shopDailyOrderDetails"
        multi-sort
        disable-pagination
        hide-default-footer
        :no-data-text="$t('shopDailyReports.Detail.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("shopDailyReports.Detail.details") }}
            </v-toolbar-title>
            <v-spacer />
            <span>
              <span class="font-weight-bold">
                {{ $t("shopDailyReports.Detail.reference")
                }}{{ $t("Global.colon") }}
              </span>
              <span class="red--text font-weight-bold">{{
                shopDailyReport.sales_volume | formatMoney
              }}</span>
            </span>
          </v-toolbar>
          <v-divider />
        </template>
        <template v-slot:item.food_code="{ item }">
          {{ item.food_code ? item.food_code : item.material_code }}
        </template>
        <template v-slot:item.food_name="{ item }">
          {{ item.food_name ? item.food_name : item.material_name }}
        </template>
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money")
          }}{{ (item.actual_sale_volume / item.sale_num) | formatMoney }}
        </template>
        <template v-slot:item.sale_volume="{ item }">
          {{ $t("Global.money") }}{{ item.sale_volume | formatMoney }}
        </template>
        <template v-slot:item.actual_sale_volume="{ item }">
          {{ $t("Global.money") }}{{ item.actual_sale_volume | formatMoney }}
        </template>
      </v-data-table>
    </v-sheet>
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import ShopDailyReports from "@/api/shop_daily_reports";
import { mapState } from "vuex";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  data: () => ({
    panels: [0],
    shopDailyReport: {},
    shopDailyOrderDetails: [],
  }),
  mounted() {
    this.getShopDailyReportFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.reportCenter"),
          disabled: false,
          href: "/report-downloads",
        },
        {
          text: i18n.t("Nav.shopDailyReports"),
          disabled: false,
          href: "/shop-daily-reports",
        },
        {
          text:
            this.shopDailyReport && this.shopDailyReport.order_code
              ? this.shopDailyReport.order_code
              : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    detailsHeaders: () => [
      {
        text: i18n.t("shopDailyReports.Detail.food_code"),
        align: "start",
        value: "food_code",
      },
      {
        text: i18n.t("shopDailyReports.Detail.food_name"),
        align: "start",
        value: "food_name",
      },
      {
        text: i18n.t("shopDailyReports.Detail.sale_num"),
        align: "start",
        value: "sale_num",
      },
      {
        text: i18n.t("shopDailyReports.Detail.sale_unit"),
        align: "start",
        value: "sale_unit",
      },
      {
        text: i18n.t("shopDailyReports.Detail.price"),
        align: "start",
        value: "price",
      },
      {
        text: i18n.t("shopDailyReports.Detail.sale_volume"),
        align: "start",
        value: "sale_volume",
      },
      {
        text: i18n.t("shopDailyReports.Detail.actual_sale_volume"),
        align: "start",
        value: "actual_sale_volume",
      },
      {
        text: i18n.t("shopDailyReports.Detail.food_behavior_name"),
        align: "start",
        value: "food_behavior_name",
      },
    ],
    ...mapState(["accountUser", "userType"]),
  },
  methods: {
    getShopDailyReportFromAPI() {
      ShopDailyReports.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopDailyReport = response.data.shop_daily_orders;
            this.shopDailyOrderDetails =
              response.data.shop_daily_orders.shop_daily_order_details;
          }
        }.bind(this)
      );
    },
  },
  watch: {
    shopDailyReport: {
      handler() {
        // console.log(this.shopDailyReport);
      },
    },
    shopDailyOrderDetails: {
      handler() {
        // console.log(this.shopDailyOrderDetails);
      },
    },
  },
};
</script>
